module.exports = __webpack_public_path__ + "img/la-rambla.ea88d97f.jpg";